import type { AdvanceTableConfig } from '@aibees/shared/features';
import type { SxStyle } from '@aibees/shared/theme';
import { renderElement } from '@aibees/shared/utils';
import { Box, Stack, TableCell, TableRow, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { mergeSx } from 'merge-sx';
import { EmptyContent, EmptyContentProps } from '../empty-content';
import { Icon } from '../icon';
import * as SX from './sx';

type Props = {
  sx?: SxStyle;
  config?: AdvanceTableConfig['emptyProps'];
  isError: boolean;
};

export type WithTableNoDataProps = {
  defaultRender: any;
  isError: boolean;
};

export const Cell = styled(TableCell)`
  border-bottom: none !important;
`;

export default function TableNoData({ sx, config, isError }: Props) {
  const defaultProps = typeof config === 'object' ? config : {};

  const defaultRender = (
    <EmptyContent
      filled
      title="No Data"
      sx={{
        py: 10,
        ...sx,
      }}
      {...defaultProps}
    />
  );

  const emptyOptions = config as EmptyContentProps;
  if (!config) return null;

  return (
    <TableRow sx={SX.tableNoDataRow}>
      <Cell className="TableNoDataCell" colSpan={12} sx={SX.tableNoDataCell}>
        {emptyOptions.emptyIcon ? (
          <Stack
            alignItems="center"
            sx={mergeSx(SX.noDataContent, emptyOptions.emptyIconWrapperSX)}
            gap={3}
            justifyContent="center"
          >
            {emptyOptions.emptyIcon && (
              <Box sx={SX.emptyIconBox}>
                <Stack sx={SX.emptyIconWrapper}>
                  <Icon
                    name={emptyOptions.emptyIcon}
                    sxx={SX.emptyIcon}
                    size={emptyOptions.iconSize || 36}
                  />
                </Stack>
              </Box>
            )}

            <Box sx={SX.noDataTitleBox}>
              <Box sx={SX.noDataTitleBox1}></Box>
              <Box sx={SX.noDataTitleBox2}></Box>
              <Stack
                sx={mergeSx(SX.noDataTitleWrapper, emptyOptions.titleWrapperSX)}
                justifyContent="center"
                alignItems="center"
                className="no-data-title-wrapper"
              >
                <Typography
                  variant="body3"
                  color="grey.500"
                  sx={mergeSx(SX.titleSx, emptyOptions.titleSx)}
                >
                  {emptyOptions.title || 'No Result Found'}
                </Typography>
              </Stack>
            </Box>
          </Stack>
        ) : (
          renderElement(config, { defaultRender, isError }, defaultRender)
        )}
      </Cell>
    </TableRow>
  );
}
